import { render, staticRenderFns } from "./AppCarouselCommentNotificationItem.vue?vue&type=template&id=de9a4882"
import script from "./AppCarouselCommentNotificationItem.vue?vue&type=script&lang=js"
export * from "./AppCarouselCommentNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./AppCarouselCommentNotificationItem.vue?vue&type=style&index=0&id=de9a4882&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports